import type Plivo from 'plivo-browser-sdk'
import { usePhoneStore } from 'v2/state/phone'
import type { PlivoConfig } from 'v2/types/call'
import { phoneLogger } from '../../logger'
import type { IConnectionManager } from '../types'

export class ConnectionManager implements IConnectionManager {
  sdk: Plivo | null = null

  private username = ''

  private password = ''

  private headers: string[] = []

  async initialize({ username, password }: PlivoConfig): Promise<void> {
    this.username = username
    this.password = password
  }

  getUsername(): string {
    return this.username
  }

  connect(headers: string[]): void {
    if (!this.username || !this.password) {
      phoneLogger.warn('Cannot connect - username or password not set')
      return
    }

    if (this.sdk?.client.isRegistered() || this.isConnecting()) {
      phoneLogger.debug('Connection already in progress')
      return
    }

    this.headers = headers

    phoneLogger.local('connecting to sdk via login method')
    this.sdk?.client.login(this.username, this.password)
  }

  getHeaders(): string[] {
    return this.headers
  }

  isConnected(): boolean {
    return this.sdk?.client?.isConnected() || false
  }

  isConnecting(): boolean {
    return this.sdk?.client?.isConnecting() || false
  }

  isLoggedIn(): boolean {
    return this.sdk?.client?.isLoggedIn || false
  }

  async destroy(): Promise<void> {
    if (!this.sdk?.client) {
      phoneLogger.warn('Cannot destroy - SDK not initialized')
      return
    }

    phoneLogger.info('Destroying Plivo SDK instance')
    await this.sdk.client.logout()
    usePhoneStore.getState().reset(true)
    this.sdk = null
    phoneLogger.info('SDK destroyed successfully')
  }
}
